<template>
  <div>
    <div>
      <span class="xbed-sub-title">物资领用表</span>
    </div>
    <div class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>麗家会</BreadcrumbItem>
        <BreadcrumbItem>物资领用表</BreadcrumbItem>
      </Breadcrumb>
    </div>

     <Tabs style="width:1885px;">
      <TabPane label="物资领用表" name="1">
        <material-use></material-use>
      </TabPane>
      <TabPane label="物资归还表" name="2">
        <material-return></material-return>
      </TabPane>
      <TabPane label="物资销售表" name="3">
        <material-sales></material-sales>
      </TabPane>
    </Tabs>
  </div> 
</template>
<script>
import materialUse from './material-use'
import materialReturn from './material-return'
import materialSales from './material-sales'

export default {
  data() {
    return {};
  },
  components: {
      'material-use':materialUse,
      'material-return':materialReturn,
      'material-sales':materialSales
  }
};
</script>





// WEBPACK FOOTER //
// src/pages/cleaner/materialCollar-list/index.vue